import React from 'react'
import { Link } from 'react-router-dom'

const ServiceSidebar = (props) => {

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="col-lg-4 col-md-8">
            <div className="blog-sidebar">
                {/*<div className="widget search-widget">*/}
                {/*    <form onSubmit={SubmitHandler}>*/}
                {/*        <div>*/}
                {/*            <input type="text" className="form-control" placeholder="Search Post.." />*/}
                {/*                <button type="submit"><i className="ti-search"></i></button>*/}
                {/*        </div>*/}
                {/*    </form>*/}
                {/*</div>*/}
                <div className="wpo-newsletter-widget widget">
                    <h3>Entra nel mondo Kleeo</h3>
                    <p>Unisciti ai noi per aggiornamenti esclusivi e consigli smart per il tuo gatto.</p>
                    <form className="form" onSubmit={SubmitHandler}>
                        <input type="text" placeholder="Email"/>
                            <button type="submit">Iscriviti</button>
                    </form>
                    <span>Iscrivendoti accetti la nostra <Link to="/privace">Privacy Policy</Link></span>
                </div>
            </div>
        </div>

    )
}

export default ServiceSidebar;


